import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";
import { uploadInChunks } from "src/domains/projects-list/api/chunkedUpload/uploadInChunks";

export interface UploadDrawingBundleParams {
  /** 업로드 파일명 `{이름}.zip` — stem 이 묶음 식별자. NFD 정규화는 호출 측 책임. */
  fileName: string;
  /** dwg n장(+ 정렬 dxf n장)을 담은 zip. */
  file: File;
}

/** 마지막 청크 응답의 `bundle` — 이 zip 이 **방금 만든** 도면들. 카탈로그를 다시 읽기 전에 무엇이 생겼는지 아는 유일한 자리다. */
export interface DrawingBundleExpansion {
  name: string;
  status: "expanding" | "ready" | "failed";
  /** 전개가 만든 도면 식별자들 — 카탈로그 평면 목록의 `name` 과 같은 값. */
  drawing_names: string[];
}

/**
 * 묶음 zip 을 올린다 — dwg·정렬과 **같은** 512KB 청크 규약(`uploadInChunks` 공용 헬퍼 위임)이고,
 * 완료 판정만 `name` 이 아니라 마지막 청크 응답의 `bundle` 이다. 그 응답이 도착한 시점에 서버는 이미
 * zip 을 열어 `drawing_names` 의 도면 행을 만들어 두었다.
 *
 * 서버가 스스로 거르는 것: `.zip` 아닌 확장자(400) · dwg 가 하나도 없는 zip(400) · 묶음 이름이 이
 * 프로젝트의 도면 이름과 겹침(409) · zip 안의 dwg 가 이 묶음 밖의 기존 도면과 겹침(409, 그 이름들을
 * 본문에 싣는다) · 권한(비멤버 404 · 멤버지만 writer 아님 403). 그래서 이 함수에는 사전 검사가 없고,
 * 거부 사유는 `uploadInChunks` 가 Error 에 붙여 올린다(`detail`).
 */
export async function uploadDrawingBundle(
  projectId: number,
  { fileName, file }: UploadDrawingBundleParams
): Promise<DrawingBundleExpansion> {
  return uploadInChunks<DrawingBundleExpansion>({
    url: `${backendBaseUrl()}/projects/${projectId}/drawing-meshes/bundles/uploads`,
    fileName,
    file,
    pickCompletion: (data) => data.bundle as DrawingBundleExpansion | undefined,
    label: "묶음 zip 업로드",
  });
}
